'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import { Button } from '@/shared/ui/button';
interface Props {
  goFeedback: () => void;
  feedbackLoading: boolean;
}
export const ReviewsHeader: React.FC<Props> = ({
  goFeedback,
  feedbackLoading
}) => {
  const t = useTranslations();
  return <header className="mb-4 flex items-center justify-between" data-sentry-component="ReviewsHeader" data-sentry-source-file="ReviewsHeader.tsx">
      <h2 className="text-xl">{`${t('doctor.reviews.title')}`}</h2>

      <Button variant={'secondary-main'} textWeight={'bold'} className="p-3" onClick={goFeedback} loading={feedbackLoading} data-sentry-element="Button" data-sentry-source-file="ReviewsHeader.tsx">
        {`${t('doctor.reviews.create_review')}`}
      </Button>
    </header>;
};